import React from 'react';
import { Grid, TextField, Autocomplete, Typography, Box, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Locations } from '../../constants/options';

const EquipmentsSection = ({ formData, handleChange, setFormData, errors }) => {
  const skinPrepOptions = ["Chlorhexidine", "Povidone iodine", "lodophor scrub", "Alcohol prep", "Other"];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" sx={{ color: '#008080', mb: 2, fontWeight: 'bold' }}>
        Step 4: Skin Preparation & Electrocautery
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>Skin Preparation</Typography>
          <TextField
              select
              label="Select Skin Prep"
              fullWidth
              name="skin_preparation"
              value={formData.skin_preparation || ''}
              onChange={handleChange}
              size="small"
            >
              {skinPrepOptions.map((opt) => (
                <MenuItem key={opt} value={opt}>{opt}</MenuItem>
              ))}
            </TextField>
            {formData.skin_preparation === "Other" && (
              <TextField
                fullWidth
                label="Other Skin Preparation"
                name="skin_preparation_other"
                value={formData.skin_preparation_other || ''}
                variant="outlined"
                margin="normal"
                onChange={handleChange}
                size="small"
              />
            )}
        </Grid>
        
        <Grid item xs={12} sm={6}>
           <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>Electrocautery: Monopolar Pad Location</Typography>
           <Autocomplete
            freeSolo
            options={Locations}
            value={formData.monopolar_pad_location || ''}
            onChange={(_, newValue) => setFormData(prev => ({ ...prev, monopolar_pad_location: newValue }))}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Pad Location"
                fullWidth
                required
                InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'red' } } }}
                size="small"
                error={!!errors.monopolar_pad_location}
                helperText={errors.monopolar_pad_location}
              />
            )}
          />
        </Grid>
      </Grid>

      <Typography variant="subtitle1" sx={{ mt: 4, mb: 1, fontWeight: 'bold' }}>Tourniquet Details</Typography>
      <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Tourniquet Location</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Applied Time</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Released Time</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Other Equipment Used</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <TableRow key={i}>
                <TableCell>
                  <TextField 
                    name={`tourniquet_location.tourniquet_location_${i}`} 
                    value={formData.tourniquet_location[`tourniquet_location_${i}`] || ''} 
                    onChange={handleChange} 
                    fullWidth size="small"
                  />
                </TableCell>
                <TableCell>
                  <TextField 
                    type="time" 
                    name={`applied_time.applied_time_${i}`} 
                    value={formData.applied_time[`applied_time_${i}`] || ''} 
                    onChange={handleChange} 
                    fullWidth size="small" 
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                  />
                </TableCell>
                <TableCell>
                  <TextField 
                    type="time" 
                    name={`released_time.released_time_${i}`} 
                    value={formData.released_time[`released_time_${i}`] || ''} 
                    onChange={handleChange} 
                    fullWidth size="small" 
                    InputLabelProps={{ shrink: true }}
                    variant="standard"
                  />
                </TableCell>
                <TableCell>
                  <TextField 
                    name={`other_equipment_used.equipment_${i}`} 
                    value={formData.other_equipment_used[`equipment_${i}`] || ''} 
                    onChange={handleChange} 
                    fullWidth size="small"
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default EquipmentsSection;
